import { Component } from '@angular/core';

@Component({
  selector: 'app-howto-section',
  imports: [],
  templateUrl: './howto-section.html',
  styleUrl: './howto-section.css',
})
export class HowtoSection {}
